import { Model } from '@vuex-orm/core';

export default class Katastralgemeinde extends Model {
  static entity = 'katastralgemeinde';
  /**
   * @param {import('@vuex-orm/core').Record} record
   */
  constructor(record) {
    super(record);
    /** @type {number} */
    this.id;
    /** @type {string} */
    this.name;
    /** @type {number} */
    this.bezirk;
    /** @type {number} */
    this.politischegemeinde;
  }

  static fields() {
    return {
      id: this.number(null),
      name: this.string(''),
      bezirk: this.number(0),
      politischegemeinde: this.number(0)
    };
  }
}
